export enum AppointmentCategoryEnum {
  JunkRemoval = 1,
  Labor = 4,
  Moving = 5,
  ExpressJunk = 8,
  MoveLabor = 7,
}
